import { createTheme } from "@mui/material/styles";

/**
 * Official Jandi branding — primary #4285F4, Object Sans typography.
 * Used app-wide so MuiButton/MuiTab/CircularProgress `color="primary"` match the spec.
 */
export const jandiTheme = createTheme({
  palette: {
    primary: {
      main: "#4285F4",
      light: "#669DF6",
      dark: "#1967D2",
      contrastText: "#ffffff",
    },
  },
  typography: {
    fontFamily:
      '"Object Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          fontSize: "15px",
          textTransform: "none",
          "@media (min-width: 640px)": {
            fontSize: "16px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
});
